<template>
  <VueFaqAccordion :items="myItems" />
</template>

<script>
import VueFaqAccordion from "vue-faq-accordion";

export default {
  components: {
    VueFaqAccordion
  },
  data() {
    return {
      myItems: [
        {
          title: "What are the most common signs of bed bugs?",
          value:
            "The most common signs of bed bugs include bite symptoms, small brown spots (fecal spots) on bedding and small blood smears on sheet."
        },
        {
          title: "Where do bed bugs normally hide?",
          value:
            "Bed bugs usually hide in cracks and crevices and live in groups and clusters when not in feeding. These places are usually near their victims as this allows them to quickly escape after sucking their blood. Some of the common places they are found include bed sheets, mattresses, bed frames, especially wooden bed frames as bed bugs tend to prefer wood or paper as compared to metal surfaces."
        },
        {
          title:
            "What are the potential health issues that can be caused by bed bugs?",
          value:
            "Bed bugs can be a nuisance because they disrupt the sleep of humans with the bites on their face, neck, arms, legs while they are asleep. A wheal is formed as a common response after being bitten, which is a spot of swelling at the attacked area of the skin due to an allergic reaction. Itching is followed on thereafter which may last for several hours. In more severe cases, asthmatic symptoms occur, and if the affected area is near the eye, the eyelid maybe swollen shut affecting vision. Other problems include constant agitation, sleeplessness and nervousness."
        },
        {
          title: "Why are bed bugs so hard to treat?",
          value:
            "Bedbugs should not be equated with filth or sanitation problems. Bedbugs are very elusive, transient pests and are extremely difficult to eliminate. They are often found in other areas besides the bed. And they are hardy. They can live for a year or more without eating and can withstand a wide range of temperatures from nearly freezing to 122 degrees Fahrenheit. Bedbugs can be controlled with vigilance, constant inspection and treatment by professional pest control service technicians."
        },
        {
          title: "What can a consumer do to protect themselves from bed bugs infestations?",
          value:
            "It is advisable to frequently vacuum the area to help eliminate the bed bugs. To prevent cross infestation, the vacuum cleaner bag should be tied in a plastic bag before disposal. Laundering bedding and clothing in hot water would also be a good preventive measure."
        }
      ]
    };
  }
};
</script>
<style scoped>
.faq ::v-deep .faq-wrapper {
  max-width: 100% !important;
}
</style>